import { FC, Fragment } from 'react'

import styled from 'styled-components'
import { Divider } from 'antd'
import { useMediaQuery } from 'react-responsive'

import { useGetArtistBalanceHistoryQuery } from 'src/Redux/artistBalanceHistoryApi'
import { UnionBalanceItem } from 'src/Components/ArtistBalanceItem'
import { MAX_MOBILE_WIDTH, MAX_TABLET_WIDTH } from 'src/Styled/variables'
import { groupArtistBalanceHistoryByDate } from 'src/Redux/artistBalanceHistoryApi/groupArtistBalanceHistoryByDate'
import { PrimarySkeleton } from 'src/Components/Skeletons/PrimarySkeleton'

import { BalanceEmptyList } from './BalanceEmptyList'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 40px;
  align-self: stretch;
  @media screen and (min-width: ${MAX_MOBILE_WIDTH}) {
    padding: 40px;
    border-radius: 16px;
    border: 1px solid ${({ theme }) => theme.color.lightGrey};
    background-color: ${({ theme }) => theme.color.white};
    box-shadow: ${({ theme }) => theme.shadow.card};
  }
`
const Title = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 28px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
`
const ListItemDate = styled(Title)`
  width: 100%;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  @media screen and (min-width: ${MAX_TABLET_WIDTH}) {
    display: none;
  }
`

const List = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`

const StyledDivider = styled(Divider)`
  margin: 0;
  border-color: ${({ theme }) => theme.color.lightGrey};
`

const StyledSkeleton = styled(PrimarySkeleton)`
  border-radius: 16px;
  height: 120px;
`

export const BalanceDetails: FC = () => {
  const isMobile = useMediaQuery({ maxWidth: MAX_TABLET_WIDTH })
  const { data: artistBalanceHistoryData, isFetching } =
    useGetArtistBalanceHistoryQuery(null, {
      refetchOnMountOrArgChange: true,
      selectFromResult: (result) => ({
        ...result,
        data: groupArtistBalanceHistoryByDate(result.data),
      }),
    })
  if (isFetching) {
    return <StyledSkeleton role='skeleton' />
  }

  if (!artistBalanceHistoryData || !artistBalanceHistoryData.length) {
    return (
      <Container>
        <Title>Balance</Title>
        <BalanceEmptyList />
      </Container>
    )
  }

  return (
    <Container>
      <Title>Balance</Title>
      <List>
        {artistBalanceHistoryData?.map((item, firstIndex) => (
          <Fragment key={item.date}>
            <ListItemDate>{item.date}</ListItemDate>
            {item.items.map((subItem, secondIndex) => (
              <Fragment key={subItem.id}>
                <UnionBalanceItem {...subItem} />
                {secondIndex !== item.items.length - 1 && (
                  <StyledDivider variant='dashed' dashed />
                )}
              </Fragment>
            ))}
            {!isMobile &&
              firstIndex !== artistBalanceHistoryData.length - 1 && (
                <StyledDivider variant='dashed' dashed />
              )}
          </Fragment>
        ))}
      </List>
    </Container>
  )
}
